import AboutHero from "./components/AboutHero";
import OurValues from "./components/OurValues";

const About = () => {
  return (
    <>
      <AboutHero />
      <OurValues />
    </>
  );
};

export default About;
